export default __webpack_public_path__ + "static/media/resume.b17a9e4a.pdf";